import firebase from "../../config/firebase";
import api from "../api/client";

require("firebase/auth");

const authApi = {
  /**
   * Altera senha Auth de um usuário via Admin SDK no backend.
   * POST /auth/update-password
   */
  async updatePassword({ uid, email, password }) {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      throw new Error("Usuário não autenticado");
    }

    const idToken = await currentUser.getIdToken(true);

    return api.post(
      "/auth/update-password",
      {
        ...(uid ? { uid } : {}),
        ...(email ? { email } : {}),
        password,
      },
      {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      },
    );
  },
};

export default authApi;
